(function () {
  'use strict';

  var VARIANTS = ['contact-client', 'contact-debtor'];
  var modal = document.getElementById('summit-consultation-modal');
  if (!modal) return;

  var dialog = modal.querySelector('.summit-consultation-modal__dialog');
  var lastTrigger = null;

  function getVariantFromHash(hash) {
    var value = (hash || '').replace(/^#/, '');
    return VARIANTS.indexOf(value) !== -1 ? value : null;
  }

  function getHrefVariant(href) {
    if (!href) return null;
    var hashIndex = href.indexOf('#');
    if (hashIndex === -1) return null;
    return getVariantFromHash(href.slice(hashIndex));
  }

  function showVariant(variant) {
    var panels = modal.querySelectorAll('[data-consultation-panel]');
    for (var i = 0; i < panels.length; i++) {
      var panel = panels[i];
      var isActive = panel.getAttribute('data-consultation-panel') === variant;
      panel.hidden = !isActive;
    }
    modal.setAttribute('data-consultation-active', variant || '');

    var active = modal.querySelector('[data-consultation-panel="' + variant + '"]');
    if (active) {
      dialog.setAttribute('aria-labelledby', active.getAttribute('data-labelledby') || '');
      dialog.setAttribute('aria-describedby', active.getAttribute('data-describedby') || '');
    }
  }

  function openModal(variant, trigger) {
    if (VARIANTS.indexOf(variant) === -1) {
      variant = 'contact-client';
    }

    lastTrigger = trigger || document.activeElement;
    showVariant(variant);
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('summit-modal-open');

    if (window.location.hash !== '#' + variant) {
      if (history.replaceState) {
        history.replaceState(null, '', '#' + variant);
      } else {
        window.location.hash = variant;
      }
    }

    window.setTimeout(function () {
      // Selects in previously-hidden panels need a Select2 refresh for width/position.
      if (window.jQuery && window.ThemeJS && ThemeJS.Functions && ThemeJS.Functions.init_select2) {
        window.jQuery('select', modal).each(function () {
          ThemeJS.Functions.init_select2(this, true);
        });
      }

      var activePanel = modal.querySelector('[data-consultation-panel="' + variant + '"]');
      var firstField = activePanel
        ? activePanel.querySelector('input:not([type="hidden"]), select, textarea, button')
        : null;
      (firstField || dialog).focus();
    }, 220);
  }

  function closeModal() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('summit-modal-open');
    modal.setAttribute('data-consultation-active', '');

    if (getVariantFromHash(window.location.hash)) {
      if (history.replaceState) {
        history.replaceState(null, '', window.location.pathname + window.location.search);
      }
    }

    if (lastTrigger && typeof lastTrigger.focus === 'function') {
      lastTrigger.focus();
    }
  }

  // Capture phase so we win over theme hash-link smooth-scroll.
  document.addEventListener('click', function (event) {
    var link = event.target.closest ? event.target.closest('a[href]') : null;
    if (link) {
      var variant = getHrefVariant(link.getAttribute('href'));
      if (variant) {
        event.preventDefault();
        event.stopImmediatePropagation();
        openModal(variant, link);
        return;
      }
    }

    if (event.target.closest && event.target.closest('[data-consultation-close]')) {
      closeModal();
    }
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && modal.classList.contains('is-open')) {
      closeModal();
    }
  });

  window.addEventListener('hashchange', function () {
    var variant = getVariantFromHash(window.location.hash);
    if (variant) {
      openModal(variant);
    } else if (modal.classList.contains('is-open')) {
      closeModal();
    }
  });

  var initialVariant = getVariantFromHash(window.location.hash);
  if (initialVariant) {
    openModal(initialVariant);
  }

  var testForms = modal.querySelectorAll('[data-test-form]');
  for (var i = 0; i < testForms.length; i++) {
    (function (testForm) {
      testForm.addEventListener('submit', function (event) {
        event.preventDefault();
        testForm.classList.add('is-success');
        var success = testForm.querySelector('[data-test-success]');
        var submit = testForm.querySelector('.summit-test-form__submit');
        if (success) success.hidden = false;
        if (submit) submit.disabled = true;
      });
    })(testForms[i]);
  }
}());
